// Licensed to the Apache Software Foundation (ASF) under one
// or more contributor license agreements.  See the NOTICE file
// distributed with this work for additional information
// regarding copyright ownership.  The ASF licenses this file
// to you under the Apache License, Version 2.0 (the
// "License"); you may not use this file except in compliance
// with the License.  You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing,
// software distributed under the License is distributed on an
// "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
// KIND, either express or implied.  See the License for the
// specific language governing permissions and limitations
// under the License.

<template>
  <a-spin :spinning="loading">
        <div v-if="!checkAllChecksAreOkay(healthChecks)">
            <div v-for="(item,idx) in healthChecks" :key="idx">
                <span  v-if="!item.success" >
                  <font-awesome-icon  style="color: #ff0000" :icon="'times'" />
                    {{ getFriendlyCheckName(item.checkname)}}
                </span>
            </div>
          </div>
        <span v-else>
            <font-awesome-icon style="color: #00cc00" :icon="'check'" />
            All checks passed
        </span>
  </a-spin>
</template>

<script>
import { ref, reactive, toRaw } from 'vue'
import { getAPI } from '@/api'
import Status from '@/components/widgets/Status'
import TooltipLabel from '@/components/widgets/TooltipLabel'

export default {
  name: 'RouterHealthCheck',
  components: {
    Status,
    TooltipLabel
  },
  props: {
    resource: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      routerHealthChecksEnabled: false,
      healthChecks: [],
      loading: false,
      columns: [
        {
          title: this.$t('label.router.health.check.name'),
          dataIndex: 'checkname'
        },
        {
          title: this.$t('label.type'),
          dataIndex: 'checktype'
        },
        {
          key: 'status',
          title: this.$t('label.router.health.check.success')
        },
        {
          title: this.$t('label.router.health.check.last.updated'),
          dataIndex: 'lastupdated'
        },
        {
          title: this.$t('label.details'),
          dataIndex: 'details'
        }
      ],
      showGetHealthChecksForm: false
    }
  },
  beforeCreate () {
    this.apiParams = this.$getApiParams('getRouterHealthCheckResults')
  },
  watch: {
    resource: {
      deep: true,
      handler (newItem) {
        this.updateResource(newItem)
      }
    }
  },
  created () {
    this.initForm()
    this.updateResource(this.resource)
  },
  methods: {
    getFriendlyCheckName(name) {
      switch (name) {
        case 'connectivity.test':
          return 'Connectivity'
        case 'cpu_usage_check.py':
          return 'CPU Usage'
        case 'dhcp.service':
          return 'DHCP Service'
        case 'dhcp_check.py':
          return 'DHCP Consistency'
        case 'disk_space_check.py':
          return 'Disk space'
        case 'dns_check.py':
          return 'DNS Consistency'
        case 'filesystem.writable.test':
          return 'Filesystem writable'
        case 'haproxy_check.py':
          return 'HAProxy status'
        case 'iptables_check.py':
          return 'Firewall rules'
        case 'loadbalancing.service':
          return 'Loadbalancing service'
        case 'memory_usage_check.py':
          return 'Memory usage'
        case 'router_version_check.py':
          return 'Version check'
        case 'ssh.service':
          return 'SSH'
        case 'webserver.service':
          return 'Web server'
        default:
          return name
      }
    },
    checkAllChecksAreOkay(data) {
        for (let i in data) {
            if (data[i].success != true) {
                return false
            }
        }
        return true
    },
    initForm () {
      this.formRef = ref()
      this.form = reactive({})
      this.rules = reactive({})
    },
    updateResource (resource) {
      if (!resource) {
        return
      }
      if (!resource.id) {
        return
      }
      this.checkConfigurationAndGetHealthChecks()
    },
  
    checkConfigurationAndGetHealthChecks (performFreshChecks) {
      var params = { name: 'router.health.checks.enabled' }
      this.loading = true
      getAPI('listConfigurations', params).then(json => {
        this.routerHealthChecksEnabled = false
        if (json.listconfigurationsresponse.configuration !== null) {
          var config = json.listconfigurationsresponse.configuration[0]
          if (config && config.name === params.name) {
            this.routerHealthChecksEnabled = config.value === 'true'
          }
        }
      }).catch(error => {
        this.$notifyError(error)
      }).finally(f => {
        this.loading = false
        if (this.routerHealthChecksEnabled) {
          this.getHealthChecks(performFreshChecks)
        }
      })
    },
    getHealthChecks (performFreshChecks) {
      var params = { routerid: this.resource.id }
      if (performFreshChecks) {
        params.performfreshchecks = performFreshChecks
      }
      this.loading = true
      getAPI('getRouterHealthCheckResults', params).then(json => {
        this.healthChecks = json.getrouterhealthcheckresultsresponse.routerhealthchecks.healthchecks
      }).catch(error => {
        this.$notifyError(error)
      }).finally(f => {
        this.loading = false
      })
    }
  }
}
</script>
